/**
 * ArrayPreviewDialog Component
 * Dialog za pregled array vrijednosti
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Button,
  Alert,
} from '@mui/material';
import { ArrayPreviewData } from '../types';

interface ArrayPreviewDialogProps {
  open: boolean;
  onClose: () => void;
  data: ArrayPreviewData;
}

export function ArrayPreviewDialog({ open, onClose, data }: ArrayPreviewDialogProps) {
  const hasObjectValues = data.values.length > 0 && typeof data.values[0] === 'object';
  const objectKeys = hasObjectValues ? Object.keys(data.values[0] || {}) : [];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Pregled vrijednosti: {data.field}
        <Typography variant="caption" display="block" color="text.secondary">
          {data.values.length} stavki u arrayu
        </Typography>
      </DialogTitle>

      <DialogContent>
        <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 400 }}>
          <Table size="small" stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: 50 }}>#</TableCell>
                <TableCell>Vrijednost / Struktura</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.values.map((item, idx) => (
                <TableRow key={idx}>
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>
                    {typeof item === 'object' ? (
                      <Box
                        component="pre"
                        sx={{ m: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap' }}
                      >
                        {JSON.stringify(item, null, 2)}
                      </Box>
                    ) : (
                      String(item)
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {hasObjectValues && (
          <Alert severity="info" sx={{ mt: 2 }}>
            <Typography variant="body2">
              <strong>Dostupni ključevi:</strong> {objectKeys.join(', ')}
            </Typography>
            <Typography variant="caption" display="block" sx={{ mt: 1 }}>
              Tip: Za mapiranje specifikacija/atributa, koristi polje "Specifikacije" ili
              "Atributi" koje će automatski pretvoriti ove objekte u key-value parove.
            </Typography>
          </Alert>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Zatvori</Button>
      </DialogActions>
    </Dialog>
  );
}
